import styled from 'styled-components'
import { PoolView, fmtUsd } from 'views/TradingCompetitionV3/pool-search/logic'

const Select = styled.select`
  width: 100%;
  min-height: 44px;
  padding: 0 12px;
  border-radius: 14px;
  font-family: inherit;
  font-weight: 700;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
  background: rgba(5, 7, 19, 0.6);
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`

/** "PancakeSwap V3 · CBON/USDT 0.25% · $56K": the exchange, the pair, the fee tier and how deep the pool is. The list arrives strongest first. */
export const poolOptionLabel = (p: PoolView) => `${p.dex} · ${p.pair}${p.feeLabel ? ` ${p.feeLabel}` : ''}${p.liquidityUsd !== null && p.liquidityUsd !== undefined ? ` · ${fmtUsd(p.liquidityUsd)}` : ''}`

/** The pool choice of a token page. The chart and the trade panel each show one of these, both bound to the same state, so they never disagree. */
export default function PoolPicker({ pools, value, onChange, testId, label }: { pools: PoolView[]; value: string | null; onChange: (pool: string) => void; testId: string; label: string }) {
  return (
    <Select value={value ?? ''} onChange={(e) => onChange(e.target.value)} aria-label={label} data-testid={testId}>
      {pools.map((p) => (
        <option key={p.pool} value={p.pool}>
          {poolOptionLabel(p)}
        </option>
      ))}
    </Select>
  )
}
